import React from "react";

const ThreeDotIcon = () => {
  return (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.91667 9.91797C2.42293 9.91797 2.83333 9.50756 2.83333 9.0013C2.83333 8.49504 2.42293 8.08464 1.91667 8.08464C1.41041 8.08464 1 8.49504 1 9.0013C1 9.50756 1.41041 9.91797 1.91667 9.91797Z"
        stroke="#0C1421"
        stroke-width="1.83333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.91667 3.5013C2.42293 3.5013 2.83333 3.0909 2.83333 2.58464C2.83333 2.07837 2.42293 1.66797 1.91667 1.66797C1.41041 1.66797 1 2.07837 1 2.58464C1 3.0909 1.41041 3.5013 1.91667 3.5013Z"
        stroke="#0C1421"
        stroke-width="1.83333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.91667 16.3346C2.42293 16.3346 2.83333 15.9242 2.83333 15.418C2.83333 14.9117 2.42293 14.5013 1.91667 14.5013C1.41041 14.5013 1 14.9117 1 15.418C1 15.9242 1.41041 16.3346 1.91667 16.3346Z"
        stroke="#0C1421"
        stroke-width="1.83333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ThreeDotIcon;
